'use es6';

import PropTypes from 'prop-types';
import { Map as ImmutableMap, List, Set as ImmutableSet, fromJS } from 'immutable';
import immutablePropTypes from 'react-immutable-proptypes';
import { COUNT } from 'reporting-data/constants/metricTypes';
export const createStagesReport = forecastReport => {
  const filters = forecastReport.getIn(['config', 'filters']).update('custom', (customFilters = ImmutableSet()) => ImmutableSet(customFilters).merge([ImmutableMap({
    operator: 'GT',
    property: 'dealstage.probability',
    value: 0
  })]).toList());
  const limit = forecastReport.getIn(['config', 'limit']);
  return fromJS({
    chartType: 'TABLE',
    config: {
      configType: 'AGGREGATION',
      dataType: 'DEALS',
      filters,
      limit,
      sort: [{
        metricType: 'AVG',
        order: 'DESC',
        property: 'dealstage.probability',
        type: 'METRIC'
      }],
      dimensions: ['dealstage'],
      metrics: [{
        property: 'hs_projected_amount_in_home_currency',
        metricTypes: ['SUM']
      }, {
        property: 'dealstage.probability',
        metricTypes: ['AVG']
      }],
      processors: []
    }
  });
};
export const createStageDrilldownReport = (dealStage, stageName, forecastReport) => {
  const filters = forecastReport.getIn(['config', 'filters']).update('custom', List(), custom => custom.push(ImmutableMap({
    operator: 'EQ',
    property: 'dealstage',
    value: dealStage
  })));
  const properties = ['dealname', 'amount_in_home_currency', 'associations.contact', 'closedate', 'hubspot_owner_id'];
  const report = fromJS({
    name: stageName,
    chartType: 'TABLE',
    displayParams: {
      hideKeyColumn: true
    },
    config: {
      count: 5,
      configType: 'SEARCH',
      dataType: 'DEALS',
      filters,
      sort: [{
        metricType: 'MAX',
        order: 'DESC',
        property: 'amount_in_home_currency',
        type: 'METRIC'
      }],
      metrics: properties.map(property => ({
        property,
        metricTypes: [COUNT]
      })),
      dimensions: [],
      processors: []
    }
  });
  return report;
};
export const getStagesTotal = stages => {
  return stages.reduce((sum, stage) => sum + stage.get('predictedAmount'), 0);
};
const keyNames = {
  'SUM|hs_projected_amount_in_home_currency': 'predictedAmount',
  'AVG|dealstage.probability': 'dealstage.probability',
  dealstage: 'stage'
};
export const getForecastStages = data => {
  const rows = data.getIn(['primary', 'data', 'data']).map(row => row.mapKeys(key => keyNames[key] || key));
  const total = getStagesTotal(rows);
  return rows.map(stage => stage.set('percent', stage.get('predictedAmount') / total));
};
export const forecastStagesType = immutablePropTypes.listOf(immutablePropTypes.contains({
  stage: PropTypes.string.isRequired,
  percent: PropTypes.number.isRequired,
  predictedAmount: PropTypes.number.isRequired,
  'dealstage.probability': PropTypes.number.isRequired
}));